class FloatingActions extends HTMLElement {
  connectedCallback() {
    this.chatOpen = this.querySelector('[data-chat-open]');
    this.chatPanel = this.querySelector('[data-chat-panel]');
    this.chatClose = this.querySelector('[data-chat-close]');
    this.chatAssistant = this.querySelector('chat-assistant');
    this.focusReturn = null;

    if (this.hasAttribute('data-chat-enabled') && !window.Theme?.abOff?.('chat')) {
      this.initChat();
      this.deferOnProductPage();
    }
  }

  disconnectedCallback() {
    this.deferObserver?.disconnect();
    clearTimeout(this.deferTimer);
    if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
  }

  // Mobile product pages: keep the launcher off the buy box until the shopper has scrolled past it.
  deferOnProductPage() {
    const mainAtc = document.querySelector('[data-main-atc]');
    if (!this.classList.contains('floating-actions--defer-product') || !mainAtc || !window.matchMedia('(max-width: 749px)').matches || !('IntersectionObserver' in window)) return;
    this.classList.add('is-deferred');
    const reveal = () => {
      this.classList.remove('is-deferred');
      this.deferObserver?.disconnect();
      clearTimeout(this.deferTimer);
    };
    this.deferTimer = setTimeout(reveal, 20000);
    this.deferObserver = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) reveal();
    });
    this.deferObserver.observe(mainAtc);
  }

  loadChat() {
    const src = this.chatAssistant?.dataset.chatSrc;
    if (!src || customElements.get('chat-assistant')) return Promise.resolve();
    this.chatLoading ??= import(src).catch(() => {
      this.chatLoading = null;
    });
    return this.chatLoading;
  }

  initChat() {
    const warm = () => this.loadChat();
    this.chatOpen?.addEventListener('pointerenter', warm, { once: true });
    this.chatOpen?.addEventListener('touchstart', warm, { once: true, passive: true });
    this.chatOpen?.addEventListener('focus', warm, { once: true });
    this.chatOpen?.addEventListener('click', () => this.toggleChat(true));
    this.chatClose?.addEventListener('click', () => this.toggleChat(false));
    this.chatPanel?.addEventListener('click', (event) => {
      if (event.target === this.chatPanel) this.toggleChat(false);
    });
    this.chatPanel?.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.toggleChat(false);
    });
    this.chatPanel?.addEventListener('close', () => {
      this.chatOpen?.setAttribute('aria-expanded', 'false');
      window.Theme?.lockScroll?.(false);
      this.focusReturn?.focus?.({ preventScroll: true });
    });
    this.onKeydown = (event) => {
      if (event.key !== 'Escape' || !this.chatPanel?.open) return;
      event.stopPropagation();
      this.toggleChat(false);
    };
    document.addEventListener('keydown', this.onKeydown);
  }

  toggleChat(open) {
    if (!this.chatPanel) return;
    if (open) {
      if (this.chatPanel.open) return;
      this.focusReturn = document.activeElement;
      this.chatPanel.showModal();
      window.Theme?.lockScroll?.(true);
      this.chatOpen?.setAttribute('aria-expanded', 'true');
      this.chatClose?.focus({ preventScroll: true });
      window.Theme?.track?.('chat_opened', { page: window.location.pathname });
      window.Theme?.ss?.('feat', 'chat_open', {});
      this.loadChat().then(() => {
        if (this.chatPanel.open) document.dispatchEvent(new CustomEvent('chat:panel-open'));
      });
      return;
    }
    if (this.chatPanel.open) this.chatPanel.close();
  }
}

if (!customElements.get('floating-actions')) customElements.define('floating-actions', FloatingActions);
